import { get, put } from "./api"

export async function markCoachLate(sessionId, coachId, { excused }) {
  try {
    return await put(`admin/session/${sessionId}/coachLate/${coachId}`, { excused })
  } catch (error) {
    return { error }
  }
}

export async function getSeasonIncentiveSummary(year, season) {
  try {
    return await get(`admin/incentives/summary?year=${year}&season=${season}`)
  } catch (error) {
    return { error }
  }
}
